import React, { Component } from 'react';
import { message } from 'antd';
import moment from 'moment';
import Documenti from '@common/components/Documenti';
import CommonForm from '@common/components/form';
import format from '@common/utils/formatters/_';
import allegatiStatic from '@common/utils/static/allegati'

const formLayout = (component, label_primo_file) => {

  return {
    layout: 'vertical',
    multistep: false,
    rows: [
      {
        cols: [
          {
            span: 24,
            items: [
              {
                type: 'radio',
                label: label_primo_file,
                name: 'certificato_ISO_UNI_EN_9001_settore_37',
                onChange: 'changeIso',
                option_type: 'button', // normal|button
                // le opzioni come le selects
                options: [
                  {
                    value: "1",
                    label: "Si"
                  },
                  {
                    value: "0",
                    label: "No",
                    //disabled: (component.props.tipo_accreditamento && component.props.tipo_accreditamento == accreditamentoStatic.tipo.definitivo) ? true : false
                  }
                ],
                validations:

                    [
                      {
                        type: 'required',
                        error_message: 'Campo obbligatorio',
                      },
                      {
                        pattern: '^1$',
                        message: 'Seleziona si'
                      }
                    ]
              }
            ],
          },
          {
            span: 8,
            items: [
              {
                type: 'datepicker',
                label: 'Data di conseguimento',
                name: 'data_conseguimento_iso',
                props: {
                  //size: 'large',
                  style: { width: '100%' },
                },
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_ISO_UNI_EN_9001_settore_37',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                  {
                    validator: 'pastDate'
                  }
                ],
              },
            ],
          },
          {
            span: 8,
            items: [
              {
                type: 'datepicker',
                label: 'Data di scadenza',
                name: 'data_scadenza_iso',
                props: {
                  //size: 'large',
                  style: { width: '100%' },
                },
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_ISO_UNI_EN_9001_settore_37',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                  {
                    validator: 'futureDate'
                  },
                  {
                    validator: 'afterConseguimento'
                  }
                ],
              },
            ],
          },
          // https://cb.schema31.it/cb/issue/417045
          /*
          {
            span: 8,
            items: [
              {
                type: 'datepicker',
                label: 'Data ultimo rinnovo',
                name: 'data_ultimo_rinnovo_iso',
                props: {
                  //size: 'large',
                  style: { width: '100%' },
                },
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_ISO_UNI_EN_9001_settore_37',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                  {
                    validator: 'pastDate'
                  },
                  {
                    validator: 'afterConseguimento'
                  }
                ],
              },
            ],
          },
          */
          {
            span: 12,
            items: [
              {
                type: 'input',
                input_type: 'text',
                label: 'Ente certificatore',
                name: 'ente_certificatore_iso',
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_ISO_UNI_EN_9001_settore_37',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                ],
              },
            ],
          },
          {
            span: 12,
            items: [
              {
                type: 'input',
                input_type: 'text',
                label: 'Numero certificazione',
                name: 'numero_certificato_iso',
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_ISO_UNI_EN_9001_settore_37',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                ],
              },
            ],
          },
          {
            span: 12,
            items: [
              {
                type: 'input',
                input_type: 'text',
                label: 'Codice ente certificatore',
                name: 'codice_ente_certificatore_iso',
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_ISO_UNI_EN_9001_settore_37',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        cols: [
          {
            span: 24,
            items: [
              {
                type: 'radio',
                // https://cb.schema31.it/cb/issue/417045
                // label: component.props.accreditamento && component.props.accreditamento.accreditamentotipologie && component.props.accreditamento.accreditamentotipologie[0] && component.props.accreditamento.accreditamentotipologie[0].id_tipologia == 3 ?  'Certificato salute e sicurezza sui luoghi di lavoro ISO UNI EN 9001 -settore 35- o versioni successive':'Certificato salute e sicurezza sui luoghi di lavoro ISO UNI EN 9001 -settore 37- o versioni successive',
                label: 'Certificato salute e sicurezza sui luoghi di lavoro ISO UNI EN 45001',
                name: 'certificato_salute',
                onChange: 'changeSalute',
                option_type: 'button', // normal|button
                // le opzioni come le selects
                options: [
                  {
                    value: "1",
                    label: "Si"
                  },
                  {
                    value: "0",
                    label: "No",
                    //disabled: (component.props.tipo_accreditamento && component.props.tipo_accreditamento == accreditamentoStatic.tipo.definitivo) ? true : false
                  }
                ],
                validations:
                    [
                      {
                        type: 'required',
                        error_message: 'Campo obbligatorio',
                      },
                      {
                        pattern: '^1$',
                        message: 'Seleziona si'
                      }
                    ]
              }
            ],
          },
          {
            span: 8,
            items: [
              {
                type: 'datepicker',
                label: 'Data di conseguimento',
                name: 'data_conseguimento_salute',
                props: {
                  //size: 'large',
                  style: { width: '100%' },
                },
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_salute',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                  {
                    validator: 'pastDate'
                  }
                ],
              },
            ],
          },
          {
            span: 8,
            items: [
              {
                type: 'datepicker',
                label: 'Data di scadenza',
                name: 'data_scadenza_salute',
                props: {
                  //size: 'large',
                  style: { width: '100%' },
                },
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_salute',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                  {
                    validator: 'futureDate'
                  },
                  {
                    validator: 'afterConseguimento'
                  }
                ],
              },
            ],
          },
          // https://cb.schema31.it/cb/issue/417045
          /*
          {
            span: 8,
            items: [
              {
                type: 'datepicker',
                label: 'Data ultimo rinnovo',
                name: 'data_ultimo_rinnovo_salute',
                props: {
                  //size: 'large',
                  style: { width: '100%' },
                },
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_salute',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                  {
                    validator: 'pastDate'
                  },
                  {
                    validator: 'afterConseguimento'
                  }
                ],
              },
            ],
          },
          */
          {
            span: 12,
            items: [
              {
                type: 'input',
                input_type: 'text',
                label: 'Ente certificatore',
                name: 'ente_certificatore_salute',
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_salute',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                ],
              },
            ],
          },
          {
            span: 12,
            items: [
              {
                type: 'input',
                input_type: 'text',
                label: 'Numero certificazione',
                name: 'numero_certificato_salute',
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_salute',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                ],
              },
            ],
          },
          {
            span: 12,
            items: [
              {
                type: 'input',
                input_type: 'text',
                label: 'Codice ente certificatore',
                name: 'codice_ente_certificatore_salute',
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_salute',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        cols: [
          {
            span: 24,
            items: [
              {
                type: 'radio',
                label: 'Certificato trattamento dei dati personali ISO/IEC 27001', //component.props.accreditamento && component.props.accreditamento.accreditamentotipologie && component.props.accreditamento.accreditamentotipologie[0] && component.props.accreditamento.accreditamentotipologie[0].id_tipologia == 3 ?  'Certificato trattamento dei dati personali ISO UNI EN 9001 -settore 35- o versioni successive':'Certificato trattamento dei dati personali ISO UNI EN 9001 -settore 37- o versioni successive',
                name: 'certificato_dati',
                onChange: 'changeDati',
                option_type: 'button', // normal|button
                // le opzioni come le selects
                options: [
                  {
                    value: "1",
                    label: "Si"
                  },
                  {
                    value: "0",
                    label: "No",
                    //disabled: (component.props.tipo_accreditamento && component.props.tipo_accreditamento == accreditamentoStatic.tipo.definitivo) ? true : false
                  }
                ],
                validations:
                    [
                      {
                        type: 'required',
                        error_message: 'Campo obbligatorio',
                      },
                      {
                        pattern: '^1$',
                        message: 'Seleziona si'
                      }
                    ]
              }
            ],
          },
          {
            span: 8,
            items: [
              {
                type: 'datepicker',
                label: 'Data di conseguimento',
                name: 'data_conseguimento_dati',
                props: {
                  //size: 'large',
                  style: { width: '100%' },
                },
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_dati',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                  {
                    validator: 'pastDate'
                  }
                ],
              },
            ],
          },
          {
            span: 8,
            items: [
              {
                type: 'datepicker',
                label: 'Data di scadenza',
                name: 'data_scadenza_dati',
                props: {
                  //size: 'large',
                  style: { width: '100%' },
                },
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_dati',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                  {
                    validator: 'futureDate'
                  },
                  {
                    validator: 'afterConseguimento'
                  }
                ],
              },
            ],
          },
          //https://cb.schema31.it/cb/issue/417045
          /*
          {
            span: 8,
            items: [
              {
                type: 'datepicker',
                label: 'Data ultimo rinnovo',
                name: 'data_ultimo_rinnovo_dati',
                props: {
                  //size: 'large',
                  style: { width: '100%' },
                },
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_dati',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                  {
                    validator: 'pastDate'
                  },
                  {
                    validator: 'afterConseguimento'
                  }
                ],
              },
            ],
          },
          */
          {
            span: 12,
            items: [
              {
                type: 'input',
                input_type: 'text',
                label: 'Ente certificatore',
                name: 'ente_certificatore_dati',
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_dati',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                ],
              },
            ],
          },
          {
            span: 12,
            items: [
              {
                type: 'input',
                input_type: 'text',
                label: 'Numero certificazione',
                name: 'numero_certificato_dati',
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_dati',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                ],
              },
            ],
          },
          {
            span: 12,
            items: [
              {
                type: 'input',
                input_type: 'text',
                label: 'Codice ente certificatore',
                name: 'codice_ente_certificatore_dati',
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'certificato_dati',
                    operator: '==',
                    value: '1'
                  }
                ],
                validations: [
                  {
                    type: 'required',
                    error_message: 'Campo obbligatorio',
                  },
                ],
              },
            ],
          },
        ],
      }
    ],
    onSubmit: 'onSubmit',
  }
};

export default class IsoCertificatoForm extends Component {
  state = {
    loading: false,
    files: {},
    has_iso: 0,
    has_salute: 0,
    has_dati: 0,
    media_files: []
  };

  componentDidMount() {
    this.setState({
      media_files: this.props.ente.media,
      has_iso: this.props.values && parseInt(this.getValues().certificato_ISO_UNI_EN_9001_settore_37) === 1,
      has_salute: this.props.values && parseInt(this.getValues().certificato_salute) === 1,
      has_dati: this.props.values && parseInt(this.getValues().certificato_dati) === 1
    });
  }

  componentDidUpdate(prevProps, prevState){
    if (prevProps.ente !== this.props.ente) {
      this.setState({ media_files: this.props.ente.media });
    }

    if (prevProps.values !== this.props.values) {
      this.setState({ has_iso: this.props.values && parseInt(this.getValues().certificato_ISO_UNI_EN_9001_settore_37) === 1,
        has_salute: this.props.values && parseInt(this.getValues().certificato_salute) === 1,
        has_dati: this.props.values && parseInt(this.getValues().certificato_dati) === 1 });
    }
  }

 /* UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.ente !== this.props.ente) {
      this.setState({ media_files: newProps.ente.media });
    }

    if (newProps.values !== this.props.values) {
      this.setState({ has_iso: newProps.values && parseInt(newProps.values.certificato_ISO_UNI_EN_9001_settore_37) === 1 });
    }
  } */

  async validate() {
    return new Promise((resolve, reject) => {
      if (!this.props.isDefinitivoOrRinnovo && this.getFormData().certificato_ISO_UNI_EN_9001_settore_37 === '0') {
        resolve(true);
      } else {

        this.formRef.props.form.validateFields((errors, values) => {
          if (!errors || errors.length === 0) {

            if (this.state.media_files.filter(e => e.tipo.sottodominio === 'certificato_qualita' && e.tipo.dominio === 'ente' && e.deleted !== 1).length === 0) {
              message.error('Inserisci il certificato di qualità');
              resolve(false)
            }

            if (this.state.media_files.filter(e => e.tipo.sottodominio === 'certificato_salute' && e.tipo.dominio === 'ente' && e.deleted !== 1).length === 0) {
              message.error('Inserisci il certificato di salute');
              resolve(false)
            }

            if (this.state.media_files.filter(e => e.tipo.sottodominio === 'trattamento_dei_dati' && e.tipo.dominio === 'ente' && e.deleted !== 1).length === 0) {
              message.error('Inserisci il certificato di trattamento dei dati');
              resolve(false)
            }

            if (this.props.isDefinitivoOrRinnovo && this.state.media_files.filter(e => e.tipo.sottodominio === 'allegato_iso_9001' && e.tipo.dominio === 'ente' && e.deleted !== 1).length === 0) {
              message.error('Inserisci il documento di certificazione ISO 9001');
              resolve(false)
            }

            resolve(true);
          } else {
            message.error('Ricontrolla i campi');
            resolve(false);
          }
        });
      }
    });
  }

  getValues() {
    return format.convertBoolean([
      'certificato_ISO_UNI_EN_9001_settore_37'
    ], format.replaceFormDatesIn(['data_conseguimento_iso', 'data_ultimo_rinnovo_iso', 'data_scadenza_iso','data_conseguimento_salute', 'data_ultimo_rinnovo_salute', 'data_scadenza_salute','data_conseguimento_dati', 'data_ultimo_rinnovo_dati', 'data_scadenza_dati'], this.props.values))
  }

  getFormData() {
    return format.replaceFormDatesOut(['data_conseguimento_iso', 'data_ultimo_rinnovo_iso', 'data_scadenza_iso','data_conseguimento_salute', 'data_ultimo_rinnovo_salute', 'data_scadenza_salute','data_conseguimento_dati', 'data_ultimo_rinnovo_dati', 'data_scadenza_dati'], this.formRef.props.form.getFieldsValue());
  }

  initDataForm() {

  }

  render() { 

    // https://cb.schema31.it/cb/issue/417045
    let label_primo_file = 'Indicare il possesso del certificato ISO UNI EN 9001'; //this.props.accreditamento && this.props.accreditamento.accreditamentotipologie && this.props.accreditamento.accreditamentotipologie[0] && this.props.accreditamento.accreditamentotipologie[0].id_tipologia == 3 ? 'Indicare il possesso del certificato ISO UNI EN 9001 -settore 35- o versioni successive' : 'Indicare il possesso del certificato ISO UNI EN 9001 -settore 37- o versioni successive';

    return (
      <div>
        <CommonForm
          wrappedComponentRef={inst => (this.formRef = inst)}
          loading={this.state.loading || false}
          onSubmit={(values) => null}
          form_model={formLayout(this, label_primo_file)}
          values={this.getValues()}
          changeIso={(name, value) => {
            let new_val = parseInt(value.target.value) === 1;
            this.setState({ has_iso: new_val })
          }}
          changeSalute={(name, value) => {
            let new_val = parseInt(value.target.value) === 1;
            this.setState({ has_salute: new_val })
          }}
          changeDati={(name, value) => {
            let new_val = parseInt(value.target.value) === 1;
            this.setState({ has_dati: new_val })
          }}
          readOnly={this.props.readOnly}
          pastDate={(rule, value, cb) => {
            if (moment() < value) cb("Inserisci una data passata");
            else cb()
          }}
          futureDate={(rule, value, cb) => {
            if (moment() > value) cb("Inserisci una data futura");
            else cb()
          }}
          afterConseguimento={(rule, value, cb) => {
            if (this.formRef.props.form.getFieldsValue()['data_conseguimento_iso'] >= value) cb("Inserisci una data successiva al conseguimento");
            else cb()
          }}
        />
        {
          this.props.isDefinitivoOrRinnovo && allegatiStatic.thereAreMediasFor(this.props.GlobalStore.stubs.tipo_media, 'ente', 'allegato_iso_9001', this.props.accreditamento.tipo_accreditamento)
            ?
            <Documenti
              canDelete={!this.props.readOnly && this.props.accreditamento.stato == 1}
              canAddNote={false}
              accreditation_id={this.props.accreditamento.id}
              media_types={allegatiStatic.filteredAccreditationMedia(this.props.GlobalStore.stubs.tipo_media, this.props.accreditamento.tipo_accreditamento)}
              medias={this.state.media_files}
              unique={true}
              current_domain="ente"
              current_subdomain="allegato_iso_9001"
              required_types={allegatiStatic.filteredRequiredMedia(this.props.GlobalStore.stubs.tipo_media, 'ente', 'allegato_iso_9001')}
              ref_id={this.props.ente.id}
              readOnly={this.props.readOnly || this.props.accreditamento.stato != 1}
              onUpload={(f) => this.setState({ media_files: [...this.state.media_files, f] })}
              onDelete={(id) => this.setState({ media_files: this.state.media_files.filter(e => e.id !== id) })}
            />
            : null
        }
        {this.state.has_iso && allegatiStatic.thereAreMediasFor(this.props.GlobalStore.stubs.tipo_media, 'ente', 'certificato_qualita', this.props.accreditamento.tipo_accreditamento) ?
          <Documenti
            canDelete={!this.props.readOnly && this.props.accreditamento.stato == 1}
            canAddNote={false}
            accreditation_id={this.props.accreditamento.id}
            media_types={allegatiStatic.filteredAccreditationMedia(this.props.GlobalStore.stubs.tipo_media, this.props.accreditamento.tipo_accreditamento)}
            medias={this.state.media_files}
            unique={true}
            current_domain="ente"
            current_subdomain="certificato_qualita"
            required_types={allegatiStatic.filteredRequiredMedia(this.props.GlobalStore.stubs.tipo_media, 'ente', 'certificato_qualita')}
            ref_id={this.props.ente.id}
            readOnly={this.props.readOnly || this.props.accreditamento.stato != 1}
            onUpload={(f) => this.setState({ media_files: [...this.state.media_files, f] })}
            onDelete={(id) => this.setState({ media_files: this.state.media_files.filter(e => e.id !== id) })}
          />
          : null}
                {this.state.has_salute && allegatiStatic.thereAreMediasFor(this.props.GlobalStore.stubs.tipo_media, 'ente', 'certificato_salute', this.props.accreditamento.tipo_accreditamento) ?
          <Documenti
            canDelete={!this.props.readOnly && this.props.accreditamento.stato == 1}
            canAddNote={false}
            accreditation_id={this.props.accreditamento.id}
            media_types={allegatiStatic.filteredAccreditationMedia(this.props.GlobalStore.stubs.tipo_media, this.props.accreditamento.tipo_accreditamento)}
            medias={this.state.media_files}
            unique={true}
            current_domain="ente"
            current_subdomain="certificato_salute"
            required_types={allegatiStatic.filteredRequiredMedia(this.props.GlobalStore.stubs.tipo_media, 'ente', 'certificato_salute')}
            ref_id={this.props.ente.id}
            readOnly={this.props.readOnly || this.props.accreditamento.stato != 1}
            onUpload={(f) => this.setState({ media_files: [...this.state.media_files, f] })}
            onDelete={(id) => this.setState({ media_files: this.state.media_files.filter(e => e.id !== id) })}
          />
          : null}
                  {this.state.has_dati && allegatiStatic.thereAreMediasFor(this.props.GlobalStore.stubs.tipo_media, 'ente', 'trattamento_dei_dati', this.props.accreditamento.tipo_accreditamento) ?
          <Documenti
            canDelete={!this.props.readOnly && this.props.accreditamento.stato == 1}
            canAddNote={false}
            accreditation_id={this.props.accreditamento.id}
            media_types={allegatiStatic.filteredAccreditationMedia(this.props.GlobalStore.stubs.tipo_media, this.props.accreditamento.tipo_accreditamento)}
            medias={this.state.media_files}
            unique={true}
            current_domain="ente"
            current_subdomain="trattamento_dei_dati"
            required_types={allegatiStatic.filteredRequiredMedia(this.props.GlobalStore.stubs.tipo_media, 'ente', 'trattamento_dei_dati')}
            ref_id={this.props.ente.id}
            readOnly={this.props.readOnly || this.props.accreditamento.stato != 1}
            onUpload={(f) => this.setState({ media_files: [...this.state.media_files, f] })}
            onDelete={(id) => this.setState({ media_files: this.state.media_files.filter(e => e.id !== id) })}
          />
          : null}
      </div>
    );
  }
}

